import { useMessageFormatter } from "@react-aria/i18n";
import { filterDOMProps } from "@react-aria/utils";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import { useLink } from "@react-aria/link";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
/**
 * Provides the behavior and accessibility implementation for an in a breadcrumbs component.
 * See `useBreadcrumbs` for details about breadcrumbs.
 */

export function useBreadcrumbItem(props, ref) {
  var isCurrent = props.isCurrent,
      isDisabled = props.isDisabled,
      ariaCurrent = props['aria-current'],
      _props$elementType = props.elementType,
      elementType = _props$elementType === void 0 ? 'a' : _props$elementType,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["isCurrent", "isDisabled", "aria-current", "elementType"]);

  var _useLink = useLink(_babelRuntimeHelpersEsmExtends({
    isDisabled: isDisabled || isCurrent,
    elementType: elementType
  }, otherProps), ref),
      linkProps = _useLink.linkProps;

  var isHeading = /^h[1-6]$/.test(elementType);
  var itemProps = {};

  if (!isHeading) {
    itemProps = linkProps;
  }

  if (isCurrent) {
    itemProps['aria-current'] = ariaCurrent || 'page';
  }

  return {
    itemProps: _babelRuntimeHelpersEsmExtends({
      'aria-disabled': isDisabled
    }, itemProps)
  };
} // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ar-AE.json

var $d2a366f9ef6a15581c8f385d812e3e2$exports = {};
$d2a366f9ef6a15581c8f385d812e3e2$exports = JSON.parse("{\"breadcrumbs\":\"عناصر الواجهة\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/bg-BG.json

var $f9f9c99937388844ad0bead1bd3585f$exports = {};
$f9f9c99937388844ad0bead1bd3585f$exports = JSON.parse("{\"breadcrumbs\":\"Трохи хляб\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/cs-CZ.json

var $f192850f1579efff51dd56faff116$exports = {};
$f192850f1579efff51dd56faff116$exports = JSON.parse("{\"breadcrumbs\":\"Popis cesty\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/da-DK.json

var $d90361384aaec77f7807bb3c5c62b5a2$exports = {};
$d90361384aaec77f7807bb3c5c62b5a2$exports = JSON.parse("{\"breadcrumbs\":\"Brødkrummer\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/de-DE.json

var $c35b920d8565cbdbcd55701920c3993$exports = {};
$c35b920d8565cbdbcd55701920c3993$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumbs\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/el-GR.json

var $fa1fbe238ab9bf2e486f9adc712b3124$exports = {};
$fa1fbe238ab9bf2e486f9adc712b3124$exports = JSON.parse("{\"breadcrumbs\":\"Πλοηγήσεις breadcrumb\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/en-US.json

var $b4f3cb2c289455c29956b19718a4483$exports = {};
$b4f3cb2c289455c29956b19718a4483$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumbs\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/es-ES.json

var $a2cb32cace4987be0cac5adbab26f3$exports = {};
$a2cb32cace4987be0cac5adbab26f3$exports = JSON.parse("{\"breadcrumbs\":\"Migas de pan\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/et-EE.json

var $f026400686fc156cbd4c163a7c5$exports = {};
$f026400686fc156cbd4c163a7c5$exports = JSON.parse("{\"breadcrumbs\":\"Lingiread\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/fi-FI.json

var $c8786744df6857419a8c32db6996841$exports = {};
$c8786744df6857419a8c32db6996841$exports = JSON.parse("{\"breadcrumbs\":\"Navigointilinkit\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/fr-FR.json

var $a5398fb928a7d679a782c6faa52e3e8$exports = {};
$a5398fb928a7d679a782c6faa52e3e8$exports = JSON.parse("{\"breadcrumbs\":\"Chemin de navigation\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/he-IL.json

var $a47148d4d9738765550190d928c1$exports = {};
$a47148d4d9738765550190d928c1$exports = JSON.parse("{\"breadcrumbs\":\"שבילי ניווט\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/hr-HR.json

var $f621d038c75189be0be4f132f6c3$exports = {};
$f621d038c75189be0be4f132f6c3$exports = JSON.parse("{\"breadcrumbs\":\"Navigacijski putovi\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/hu-HU.json

var $c7906303dee64b9ea7408608de8a0cb$exports = {};
$c7906303dee64b9ea7408608de8a0cb$exports = JSON.parse("{\"breadcrumbs\":\"Morzsamenü\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/it-IT.json

var $f45b84561852c1fcb341b81caa1f8c1f$exports = {};
$f45b84561852c1fcb341b81caa1f8c1f$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumb\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ja-JP.json

var $cceb23a57a4015eb92565c9d69a51f86$exports = {};
$cceb23a57a4015eb92565c9d69a51f86$exports = JSON.parse("{\"breadcrumbs\":\"パンくずリスト\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ko-KR.json

var $c3596c15f32f0ef4e74ae9b268064555$exports = {};
$c3596c15f32f0ef4e74ae9b268064555$exports = JSON.parse("{\"breadcrumbs\":\"탐색 표시\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/lt-LT.json

var $ca55715e7cdd5bd87592aba57be03$exports = {};
$ca55715e7cdd5bd87592aba57be03$exports = JSON.parse("{\"breadcrumbs\":\"Naršymo kelias\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/lv-LV.json

var $b630e8ea2c93677f99892ac5242053e4$exports = {};
$b630e8ea2c93677f99892ac5242053e4$exports = JSON.parse("{\"breadcrumbs\":\"Atpakaļceļi\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/nb-NO.json

var $e1a31e86616b4a1633f4b5a41336957$exports = {};
$e1a31e86616b4a1633f4b5a41336957$exports = JSON.parse("{\"breadcrumbs\":\"Navigasjonsstier\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/nl-NL.json

var $d57fd6b5b7ed8bbba63ecfdc71928b08$exports = {};
$d57fd6b5b7ed8bbba63ecfdc71928b08$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumbs\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/pl-PL.json

var $ae72552922425db75bd15ad733313c3$exports = {};
$ae72552922425db75bd15ad733313c3$exports = JSON.parse("{\"breadcrumbs\":\"Struktura nawigacyjna\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/pt-BR.json

var $b1c418c75419654d626acd2e$exports = {};
$b1c418c75419654d626acd2e$exports = JSON.parse("{\"breadcrumbs\":\"Caminho detalhado\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ro-RO.json

var $c26f5fad5cededd87d599b9f971cb914$exports = {};
$c26f5fad5cededd87d599b9f971cb914$exports = JSON.parse("{\"breadcrumbs\":\"Miez de pâine\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/ru-RU.json

var $e93ae8917a534c3e2eec413fe98$exports = {};
$e93ae8917a534c3e2eec413fe98$exports = JSON.parse("{\"breadcrumbs\":\"Навигация\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/sk-SK.json

var $f5bdc2c6dd93f1f59eb5a8ba7be951d9$exports = {};
$f5bdc2c6dd93f1f59eb5a8ba7be951d9$exports = JSON.parse("{\"breadcrumbs\":\"Navigačné prvky Breadcrumbs\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/sl-SI.json

var $f496feec0cbf7872d6498d44f433229$exports = {};
$f496feec0cbf7872d6498d44f433229$exports = JSON.parse("{\"breadcrumbs\":\"Drobtine\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/sr-SP.json

var $cc132b0f84216676b0ba95ca836bcc$exports = {};
$cc132b0f84216676b0ba95ca836bcc$exports = JSON.parse("{\"breadcrumbs\":\"Putanje navigacije\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/sv-SE.json

var $dbc6c44fba6a795aa14c27df994c100$exports = {};
$dbc6c44fba6a795aa14c27df994c100$exports = JSON.parse("{\"breadcrumbs\":\"Sökvägar\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/tr-TR.json

var $eef46c35901b7e908f9dd95d6cd395c$exports = {};
$eef46c35901b7e908f9dd95d6cd395c$exports = JSON.parse("{\"breadcrumbs\":\"İçerik haritaları\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/uk-UA.json

var $c058458278a484711eae6423d5faea7$exports = {};
$c058458278a484711eae6423d5faea7$exports = JSON.parse("{\"breadcrumbs\":\"Навігаційна стежка\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/zh-CN.json

var $ac75bd68aa4384fd08b594c88a$exports = {};
$ac75bd68aa4384fd08b594c88a$exports = JSON.parse("{\"breadcrumbs\":\"导航栏\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/breadcrumbs/intl/zh-TW.json

var $e2c147cd213ac3936c165ae720c4372b$exports = {};
$e2c147cd213ac3936c165ae720c4372b$exports = JSON.parse("{\"breadcrumbs\":\"導覽列\"}"); // @ts-ignore

var $c68b69687dd7367cc55044f60a0c$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($d2a366f9ef6a15581c8f385d812e3e2$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($f9f9c99937388844ad0bead1bd3585f$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($f192850f1579efff51dd56faff116$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($d90361384aaec77f7807bb3c5c62b5a2$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($c35b920d8565cbdbcd55701920c3993$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($fa1fbe238ab9bf2e486f9adc712b3124$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($b4f3cb2c289455c29956b19718a4483$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($a2cb32cace4987be0cac5adbab26f3$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($f026400686fc156cbd4c163a7c5$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($c8786744df6857419a8c32db6996841$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($a5398fb928a7d679a782c6faa52e3e8$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($a47148d4d9738765550190d928c1$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($f621d038c75189be0be4f132f6c3$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($c7906303dee64b9ea7408608de8a0cb$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($f45b84561852c1fcb341b81caa1f8c1f$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($cceb23a57a4015eb92565c9d69a51f86$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($c3596c15f32f0ef4e74ae9b268064555$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($ca55715e7cdd5bd87592aba57be03$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($b630e8ea2c93677f99892ac5242053e4$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($e1a31e86616b4a1633f4b5a41336957$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($d57fd6b5b7ed8bbba63ecfdc71928b08$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($ae72552922425db75bd15ad733313c3$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($b1c418c75419654d626acd2e$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($c26f5fad5cededd87d599b9f971cb914$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($e93ae8917a534c3e2eec413fe98$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($f5bdc2c6dd93f1f59eb5a8ba7be951d9$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($f496feec0cbf7872d6498d44f433229$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($cc132b0f84216676b0ba95ca836bcc$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($dbc6c44fba6a795aa14c27df994c100$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($eef46c35901b7e908f9dd95d6cd395c$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($c058458278a484711eae6423d5faea7$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($ac75bd68aa4384fd08b594c88a$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($e2c147cd213ac3936c165ae720c4372b$exports).default
};
/**
 * Provides the behavior and accessibility implementation for a breadcrumbs component.
 * Breadcrumbs display a heirarchy of links to the current page or resource in an application.
 */

export function useBreadcrumbs(props) {
  var ariaLabel = props['aria-label'],
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["aria-label"]);

  var formatMessage = useMessageFormatter($c68b69687dd7367cc55044f60a0c$var$intlMessages);
  return {
    navProps: _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps, {
      labelable: true
    }), {
      'aria-label': ariaLabel || formatMessage('breadcrumbs')
    })
  };
}